import { SelectOption } from '../../interfaces/UI'

export const SeasonOptions: SelectOption[] = [
  {
    id: 13,
    label: 'Spring',
  },
  {
    id: 14,
    label: 'Summer',
  },
  {
    id: 15,
    label: 'Fall',
  },
  {
    id: 16,
    label: 'Winter',
  },
]
